<template>
    <div role="toolbar" class="tenjityModule" :class="{ 'tenjityModule-dark': isDarkModeActive }">

        <SimpleKeyboard v-if="profils.find(profil => profil.name === 'simpleKeyboard' && profil.isChecked)"
            @onChange="onChange" @onKeyPress="onKeyPress" :input="input" style="display: block" />

        <div class="tenjityModule-container" :class="{ 'tenjityModule-container-active': isModuleActive }">
            <div v-if="isModuleActive || !hasCustomCta" :data-tenjity-customcta="hasCustomCta"
                class="tenjityModule-header" role="banner" @click="toggleModule">
                <div v-if="isModuleActive" class="tenjityModule-title" role="button">
                    <div class="tenjityModule-title-click">
                        Tenji<span class="tenjityModule-title-color">ty</span>
                    </div>
                </div>
                <div class="tenjityModule-title-click" v-if="!isModuleActive" role="button">
                    Essayer <b>Tenji<span class="tenjityModule-title-color">ty</span></b>
                </div>
                <Icon v-if="!isModuleActive" class="tenjityModule-icon-close" icon="fluent:accessibility-32-regular" />
                <Icon v-else class="tenjityModule-icon-open" icon="fluent:dismiss-32-regular" />
            </div>

            <div class="tenjityModule-content" ref="accessibilityContent" role="main"
                :class="{ 'tenjityModule-content-active': isModuleActive }">
                <div class="tenjityModule-section tenjityModule-section-profil">
                    <!-- AccessibilityModuleHashError v-if="!isHashModuleValid" / -->
                    <!--<AccessibilityMultilang @selectLang="selectLang" />-->

                    <template v-for="(profil, index) in profils" :key="index">
                        <div v-if="profil.name === 'visualImpairments'"
                            class="tenjityModule-profil tenjityModule-item tenjityModule-item-profil tenjityModule-item-visualImpairments"
                            @click="toggleProfil(index, profil.name)"
                            :class="{ 'tenjityModule-item-visualImpairments-open': isZoomExpanded && profil.isChecked }">
                            <div class="tenjityModule-profil-left">
                                <AccessibilitySwitch :isChecked="profil.isChecked" />
                                <div role="button" class="tenjityModule-profil-name">{{ profil.type }}</div>
                            </div>
                            <div class="tenjityModule-profil-actions" @click.stop>
                                <Icon class="tenjityModule-item-icon tenjityModule-item-icon-profil"
                                    :icon="profil.icon" />
                                <Icon v-if="profil.isChecked" class="tenjityModule-item-customProfil-icon"
                                    :class="isZoomExpanded && 'tenjityModule-item-customProfil-icon-actif'"
                                    icon="fluent:chevron-up-12-filled" @click.stop="isZoomExpanded = !isZoomExpanded" />
                            </div>
                        </div>
                        <template v-if="profil.name === 'visualImpairments'">
                            <Transition name="tenjitySubmenu">
                                <AccessibilityZoom v-show="profil.isChecked && isZoomExpanded"
                                    :isZoomActive="zoom.state.isZoomActive" :zoomValue="zoom.state.zoomValue"
                                    :zoomMin="zoom.state.zoomMin" :zoomMax="zoom.state.zoomMax"
                                    :zoomStep="zoom.state.zoomStep" :isModuleZoomActive="zoom.state.isModuleZoomActive"
                                    :moduleZoomValue="zoom.state.moduleZoomValue"
                                    :moduleZoomMin="zoom.state.moduleZoomMin" :moduleZoomMax="zoom.state.moduleZoomMax"
                                    :moduleZoomStep="zoom.state.moduleZoomStep"
                                    :isTextZoomActive="zoom.state.isTextZoomActive"
                                    :textZoomValue="zoom.state.textZoomValue" :textZoomMin="zoom.state.textZoomMin"
                                    :textZoomMax="zoom.state.textZoomMax" :pageZoomSliderBg="zoomPageSliderBg"
                                    :moduleZoomSliderBg="zoomModuleSliderBg" :textZoomSliderBg="zoomTextSliderBg"
                                    :toggleZoom="zoom.toggleZoom" :onPageZoomSlider="zoom.onPageZoomSlider"
                                    :toggleModuleZoom="zoom.toggleModuleZoom"
                                    :onModuleZoomSlider="zoom.onModuleZoomSlider"
                                    :onTextZoomSlider="zoom.onTextZoomSlider" :resetTextZoom="zoom.resetTextZoom" />
                            </Transition>
                        </template>
                        <div v-else-if="profil.name === 'cursor'"
                            class="tenjityModule-profil tenjityModule-item tenjityModule-item-profil tenjityModule-item-cursorProfil"
                            @click="toggleProfil(index, profil.name)"
                            :class="{ 'tenjityModule-item-cursorProfil-open': isCursorSettingsMenuOpen && profil.isChecked }">
                            <div class="tenjityModule-profil-left">
                                <AccessibilitySwitch :isChecked="profil.isChecked" />
                                <div role="button" class="tenjityModule-profil-name">{{ profil.type }}</div>
                            </div>
                            <div class="tenjityModule-profil-actions" @click.stop>
                                <Icon class="tenjityModule-item-icon tenjityModule-item-icon-profil"
                                    :icon="profil.icon" />
                                <Icon v-if="profil.isChecked" class="tenjityModule-item-customProfil-icon"
                                    :class="isCursorSettingsMenuOpen && 'tenjityModule-item-customProfil-icon-actif'"
                                    icon="fluent:chevron-up-12-filled" @click.stop="toggleCursorSettingsMenu" />
                            </div>
                        </div>
                        <div v-else-if="profil.name === 'cognitiveImpairments'"
                            class="tenjityModule-profil tenjityModule-item tenjityModule-item-profil tenjityModule-item-screenRulerProfil"
                            @click="toggleProfil(index, profil.name)"
                            :class="{ 'tenjityModule-item-screenRulerProfil-open': isScreenRulerSettingsMenuOpen && profil.isChecked }">
                            <div class="tenjityModule-profil-left">
                                <AccessibilitySwitch :isChecked="profil.isChecked" />
                                <div role="button" class="tenjityModule-profil-name">{{ profil.type }}</div>
                            </div>
                            <div class="tenjityModule-profil-actions" @click.stop>
                                <Icon class="tenjityModule-item-icon tenjityModule-item-icon-profil"
                                    :icon="profil.icon" />
                                <Icon v-if="profil.isChecked" class="tenjityModule-item-customProfil-icon"
                                    :class="isScreenRulerSettingsMenuOpen && 'tenjityModule-item-customProfil-icon-actif'"
                                    icon="fluent:chevron-up-12-filled" @click.stop="toggleScreenRulerSettingsMenu" />
                            </div>
                        </div>
                        <AccessibilityToggleProfil v-else-if="profil.name !== 'colors'" :profil="profil.type"
                            :isChecked="profil.isChecked" @handleClick="toggleProfil(index, profil.name)"
                            :icon="profil.icon" profilType="app" />
                        <Transition name="tenjitySubmenu">
                            <div v-if="profil.name === 'cognitiveImpairments' && profil.isChecked && isScreenRulerSettingsMenuOpen"
                                class="tenjityModule-item tenjityModule-item-screenRuler-settings">
                                <!-- <div class="tenjityModule-item-title" role="button">Paramètres de la règle d'écran</div> -->
                                <div class="tenjityModule-item-name-small" role="button">Taille de la règle</div>
                                <div class="tenjityModule-item-btns">
                                    <AccessibilityBtn type="minus"
                                        :isDisabled="screenRulerHeight <= screenRulerHeightStep"
                                        @handleClick="changeScreenRulerHeight('minus')" />
                                    <AccessibilityInput :min="screenRulerHeightStep" unit="px"
                                        :label="'screenRulerHeight'" @handleClickInput="checkToggleScreenRuler"
                                        v-model:inputValue="screenRulerHeight" />
                                    <AccessibilityBtn type="more" @handleClick="changeScreenRulerHeight('more')" />
                                </div>
                                <div class="tenjityModule-item tenjityModule-item-formColor" role="form"
                                    title="Couleur de la règle" @click.stop>
                                    <label for="screenRulerColor"
                                        class="tenjityModule-item-name tenjityModule-item-name-color">Couleur de la
                                        règle</label>
                                    <input class="tenjityModule-item-color" type="color" id="screenRulerColor"
                                        title="Couleur" v-model="screenRulerColor" @click="$event.stopPropagation()" />
                                </div>
                            </div>
                        </Transition>
                        <Transition name="tenjitySubmenu">
                            <div v-if="profil.name === 'cursor' && profil.isChecked && isCursorSettingsMenuOpen"
                                class="tenjityModule-item tenjityModule-item-cursor-settings">
                                <!-- div class="tenjityModule-item-title" role="button">Paramètres du curseur</div -->
                                <div class="tenjityModule-item-name-small" role="button">Taille du curseur</div>
                                <div class="tenjityModule-item-btns">
                                    <AccessibilityBtn type="minus" :isDisabled="cursorScale === cursorScaleStep"
                                        @handleClick="changeCursorScale('minus')" />
                                    <AccessibilityInput :min="0" unit="%" @handleClickInput="checkToggleCursor"
                                        v-model:inputValue="cursorScale" :label="'cursorScale'" />
                                    <AccessibilityBtn type="more" @handleClick="changeCursorScale('more')" />
                                </div>
                                <div class="tenjityModule-item tenjityModule-item-formColor" role="form"
                                    title="Couleur du curseur" @click.stop>
                                    <label for="cursorColor"
                                        class="tenjityModule-item-name tenjityModule-item-name-color">Couleur du
                                        curseur</label>
                                    <input class="tenjityModule-item-color" type="color" id="cursorColor"
                                        title="Couleur" v-model="normalCursorColor" :disabled="!isCursorActive"
                                        @input="handleCursorColorInput('normalCursorColor', $event)"
                                        @click="$event.stopPropagation()" />
                                </div>
                                <div class="tenjityModule-item tenjityModule-item-formColor" role="form"
                                    title="Couleur du clique" @click.stop>
                                    <label for="clickColor"
                                        class="tenjityModule-item-name tenjityModule-item-name-color">Couleur du
                                        clique</label>
                                    <input id="clickColor" class="tenjityModule-item-color" type="color" title="Couleur"
                                        v-model="hoverCursorColor" :disabled="!isCursorActive"
                                        @input="handleCursorColorInput('hoverCursorColor', $event)"
                                        @click="$event.stopPropagation()" />
                                </div>
                            </div>
                        </Transition>
                        <div v-if="profil.name === 'visualImpairments'"
                            class="tenjityModule-profil tenjityModule-item tenjityModule-item-profil tenjityModule-item-magnifier"
                            @click="toggleMagnifier"
                            :class="{ 'tenjityModule-item-magnifier-open': isMagnifierSettingsMenuOpen && isMagnifierActive }">
                            <div class="tenjityModule-profil-left">
                                <AccessibilitySwitch :isChecked="isMagnifierActive" />
                                <div class="tenjityModule-profil-name" role="button">Loupe</div>
                            </div>
                            <div class="tenjityModule-profil-actions" @click.stop>
                                <Icon class="tenjityModule-item-icon tenjityModule-item-icon-profil"
                                    icon="fluent:search-square-24-regular" />
                                <Icon v-if="isMagnifierActive" class="tenjityModule-item-customProfil-icon"
                                    :class="isMagnifierSettingsMenuOpen && 'tenjityModule-item-customProfil-icon-actif'"
                                    icon="fluent:chevron-up-12-filled" @click.stop="toggleMagnifierSettingsMenu" />
                            </div>
                        </div>
                        <Transition name="tenjitySubmenu">
                            <div v-if="profil.name === 'visualImpairments' && isMagnifierActive && isMagnifierSettingsMenuOpen"
                                class="tenjityModule-item tenjityModule-item-magnifier-settings">
                                <!-- <div class="tenjityModule-item-title" role="button">Paramètres de la loupe</div> -->
                                <div class="tenjityModule-item-toggle" role="button" @click.stop="toggleMagnifierFrame">
                                    <div class="tenjityModule-item-name-small">Bordure et ombrage</div>
                                    <AccessibilitySwitch :isChecked="isMagnifierFrameVisible" />
                                </div>
                                <div class="tenjityModule-item-name-small">Niveau de zoom</div>
                                <div class="tenjityModule-item-btns">
                                    <AccessibilityBtn type="minus" :isDisabled="magnifierZoom <= magnifierZoomMin"
                                        @handleClick="changeMagnifierZoom('minus')" />
                                    <AccessibilityInput :min="magnifierZoomMin" :max="magnifierZoomMax" unit="x"
                                        v-model:inputValue="magnifierZoom" :label="'magnifierZoom'" />
                                    <AccessibilityBtn type="more" :isDisabled="magnifierZoom >= magnifierZoomMax"
                                        @handleClick="changeMagnifierZoom('more')" />
                                </div>
                                <div class="tenjityModule-item-name-small">Taille de la loupe</div>
                                <div class="tenjityModule-item-btns">
                                    <AccessibilityBtn type="minus" :isDisabled="magnifierSize <= magnifierSizeMin"
                                        @handleClick="changeMagnifierSize('minus')" />
                                    <AccessibilityInput :min="magnifierSizeMin" :max="magnifierSizeMax" unit="px"
                                        v-model:inputValue="magnifierSize" :label="'magnifierSize'" />
                                    <AccessibilityBtn type="more" :isDisabled="magnifierSize >= magnifierSizeMax"
                                        @handleClick="changeMagnifierSize('more')" />
                                </div>
                                <div class="tenjityModule-item tenjityModule-item-formColor" role="form"
                                    title="Mode de la loupe" @click.stop>
                                    <label for="magnifierMode"
                                        class="tenjityModule-item-name tenjityModule-item-name-color">Mode de la
                                        loupe</label>
                                    <select id="magnifierMode" class="tenjityModule-item-select" :value="magnifierMode"
                                        @change="setMagnifierMode($event.target.value)" @click.stop>
                                        <option value="cursor">Suivre le curseur</option>
                                        <option value="zone">Zone definie</option>
                                    </select>
                                </div>
                                <template v-if="magnifierMode === 'zone'">
                                    <div class="tenjityModule-item-name-small">Position horizontale</div>
                                    <div class="tenjityModule-item-btns">
                                        <AccessibilityBtn type="minus"
                                            @handleClick="changeMagnifierFixedPosition('x', 'minus')" />
                                        <AccessibilityInput :min="0" :max="magnifierViewportWidth" unit="px"
                                            :label="'magnifierFixedX'" :inputValue="magnifierFixedX"
                                            @update:inputValue="updateMagnifierFixedPosition('x', $event)" />
                                        <AccessibilityBtn type="more"
                                            @handleClick="changeMagnifierFixedPosition('x', 'more')" />
                                    </div>
                                    <div class="tenjityModule-item-name-small">Position verticale</div>
                                    <div class="tenjityModule-item-btns">
                                        <AccessibilityBtn type="minus"
                                            @handleClick="changeMagnifierFixedPosition('y', 'minus')" />
                                        <AccessibilityInput :min="0" :max="magnifierViewportHeight" unit="px"
                                            :label="'magnifierFixedY'" :inputValue="magnifierFixedY"
                                            @update:inputValue="updateMagnifierFixedPosition('y', $event)" />
                                        <AccessibilityBtn type="more"
                                            @handleClick="changeMagnifierFixedPosition('y', 'more')" />
                                    </div>
                                </template>
                            </div>
                        </Transition>
                    </template>


                    <!-- Ligne de bouton pour le mode sombre sur le module. -->
                    <div class="tenjityModule-profil tenjityModule-item tenjityModule-item-profil tenjityModule-item-theme"
                        @click="toggleDarkMode">
                        <div class="tenjityModule-profil-left">
                            <AccessibilitySwitch :isChecked="isDarkModeActive" />
                            <div class="tenjityModule-profil-name" role="button">Mode sombre</div>
                        </div>
                        <Icon class="tenjityModule-item-icon tenjityModule-item-icon-profil"
                            icon="fluent:dark-theme-24-regular" />
                    </div>

                    <div v-if="profils.find(profil => profil.name === 'colors')"
                        class="tenjityModule-profil tenjityModule-item tenjityModule-item-profil tenjityModule-item-colorsProfil"
                        @click="toggleProfil(profils.findIndex(profil => profil.name === 'colors'), 'colors')"
                        :class="{ 'tenjityModule-item-colorsProfil-open': isColorsSettingsMenuOpen && profils.find(profil => profil.name === 'colors')?.isChecked }">
                        <div class="tenjityModule-profil-left">
                            <AccessibilitySwitch
                                :isChecked="profils.find(profil => profil.name === 'colors')?.isChecked" />
                            <div role="button" class="tenjityModule-profil-name">{{profils.find(profil => profil.name
                                === 'colors')?.type
                            }}</div>
                        </div>
                        <div class="tenjityModule-profil-actions" @click.stop>
                            <Icon class="tenjityModule-item-icon tenjityModule-item-icon-profil"
                                :icon="profils.find(profil => profil.name === 'colors')?.icon" />
                            <Icon v-if="profils.find(profil => profil.name === 'colors')?.isChecked"
                                class="tenjityModule-item-customProfil-icon"
                                :class="isColorsSettingsMenuOpen && 'tenjityModule-item-customProfil-icon-actif'"
                                icon="fluent:chevron-up-12-filled" @click.stop="toggleColorsSettingsMenu" />
                        </div>
                    </div>
                    <Transition name="tenjitySubmenu">
                        <div v-if="profils.find(profil => profil.name === 'colors')?.isChecked && isColorsSettingsMenuOpen"
                            class="tenjityModule-item tenjityModule-item-colors-settings">
                            <!-- div class="tenjityModule-item-title" role="button">Paramètres</div -->
                            <AccessibilityFilters :profilFilters="profilFilters" :embedded="true"
                                @filtersChange="updateFiltersActive" @handleToggleSection="resizeModule" />
                        </div>
                    </Transition>

                    <TransitionGroup name="userProfil">
                        <AccessibilityToggleProfil v-for="(profil, index) in userProfils" :key="index"
                            :profil="profil.name" :isChecked="profil.isProfilActive"
                            @handleClick="toggleUserProfil(index)" icon="fluent:delete-dismiss-24-filled"
                            profilType="user" @handleDelete="deleteUserProfil(index)" />
                    </TransitionGroup>

                    <!-- <div class="tenjityModule-item tenjityModule-item-customProfil" @click="toggleShowCustom">
                        <div role="button" class="tenjityModule-item-name">Créer votre profil</div>
                        <Icon class="tenjityModule-item-customProfil-icon"
                            :class="isShowCustom && 'tenjityModule-item-customProfil-icon-actif'"
                            icon="fluent:chevron-up-12-filled" />
                    </div> -->

                </div>
                <div class="tenjityModule-custom" ref="customSection">
                    <!-- <AccessibilityContent ref="sectionContent" @handleToggleFont="manageWidthOnToggleFont"
                        :profilContent="profilContent" :fontForDyslexic="fontForDyslexic" :zoomWrapper="zoomWrapper"
                        @handleToggleSection="resizeModule" /> -->
                    <!-- <div class="tenjityModule-section"
                        :class="{ 'tenjityModule-section-active': isNavigationSectionActive }">
                        <AccessibilitySectionHeader :isSectionActive="isNavigationSectionActive" title="Navigation"
                            @handleClickReset="resetNavigation" @handleClickExpand="toggleNavigationSection" />
                        <div ref="navigationSectionRef"
                            :class="isNavigationSectionActive ? 'tenjityModule-section-content tenjityModule-section-content-active' : 'tenjityModule-section-content'">
                            <div class="tenjityModule-item">
                                <div class="tenjityModule-item-title" role="button">Filtre de contenu</div>
                                <div v-for="(filter, index) in contentsFilter" :key="index">
                                    <div class="tenjityModule-item-header">
                                        <Icon class="tenjityModule-item-icon tenjityModule-item-icon-content"
                                            :icon="filter.icon" />
                                        <div class="tenjityModule-item-name-small" role="button">{{ filter.name }}
                                        </div>
                                        <div class="tenjityModule-item-right"></div>
                                    </div>
                                    <button class="tenjityModule-item-btn"
                                        @click="handleFilterContent(filter.name)">Rechercher</button>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
                <div @click="handleOpenProfilModal" class="tenjityModule-item tenjityModule-item-addProfil">
                    <div class="tenjityModule-item-name" role="button">Sauvegarder le profil</div>
                    <Icon class="tenjityModule-item-icon tenjityModule-item-addProfil-icon"
                        icon="fluent:add-24-regular" />
                </div>
                <div class="tenjity-link">
                    <a role="button" href="http://tenjity.netlify.app" target="_blank"><span class="txt">un module
                        </span><span class="u">tenji<span class="ylw">ty</span></span></a>
                </div>
            </div>

        </div>
        <!-- CUSTOM CURSOR -->
        <div ref="cursorRef" class="tenjityModule-customCursor">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" overflow="visible">
                <path v-if="!isCursorPointer" :fill="cursorColor"
                    d="M4 0l16 12.279-6.951 1.17 4.325 8.817-3.596 1.734-4.35-8.879-5.428 4.702z" />
                <path v-else :style="{ transform: 'translateX(-17%)' }" :fill="cursorColor"
                    d="M4.021 10.688c1.208.172 2.51 1.312 2.979 1.781v-10.514c0-1.08.92-1.955 2-1.955s2 .875 2 1.955v6.058c0 .784.814.885.919.103.216-1.604 2.519-1.817 2.693.399.043.546.726.655.866.027.326-1.444 2.501-1.458 2.758.758.066.579.796.696.848.034.051-.67.281-.934.607-.934 1.098 0 2.309 2.019 2.309 4.41 0 4.295-3 4.306-3 11.19h-10c-.332-3.942-3.462-7.431-6.271-10.241-.488-.488-.729-1.052-.729-1.564 0-.93.759-1.688 2.021-1.507z" />
            </svg>
        </div>
        <!-- MAGNIFIER -->
        <MagnifierView ref="magnifierViewRef" :isActive="isMagnifierActive" :zoom="magnifierZoom" :size="magnifierSize"
            :mode="magnifierMode" :frameVisible="isMagnifierFrameVisible" :fixedX="magnifierFixedX"
            :fixedY="magnifierFixedY" :cursorPosition="magnifierCursorPosition"
            :moduleZoomValue="moduleZoomValueForMagnifier" :pageZoomValue="pageZoomValueForMagnifier"
            @update:zoom="magnifierZoom = $event" @update:size="magnifierSize = $event"
            @update:fixedX="magnifierFixedX = $event" @update:fixedY="magnifierFixedY = $event"
            @update:cursorPosition="magnifierCursorPosition = $event" />
        <!-- SCREEN RULER -->
        <div class="tenjityModule-screenRuler" ref="screenRulerRef">
            <div class="tenjityModule-screenRulerTop" ref="screenRulerTopRef"></div>
            <div class="tenjityModule-screenRulerBottom" ref="screenRulerBottomRef"></div>
        </div>
        <!-- MODAL -->
        <div ref="modalRef" class="tenjityModule-modal" v-if="isShowModal" @click="handleHideModal">
            <div class="tenjityModule-modal-container">
                <div class="tenjityModule-modal-header">
                    <Icon class="tenjityModule-modal-closeBtn" icon="fluent:add-16-filled" />
                    <div class="tenjityModule-modal-title" :style="titleStyle" :aria-label="filteredContent.title">
                        {{ filteredContent.title }}
                    </div>
                </div>
                <div class="tenjityModule-modal-content">
                    <ul class="tenjityModule-modal-list" v-if="filteredContent.content.length > 0">
                        <li v-for="(element, index) in filteredContent.content" :key="index"
                            class="tenjityModule-modal-item" @click="handleClickElement(element)" :style="btnStyle">
                            {{ element.innerText || element.alt || "Pas de texte" }}
                        </li>
                    </ul>
                    <p v-else class="tenjityModule-modal-empty">Pas d'items présents sur la page</p>
                </div>
            </div>
        </div>
        <!-- LOADER -->
        <div v-if="isLoading" class="tenjity-loader">
            <div class="tenjity-spinner"></div>
        </div>
        <!-- MODAL CREATE PROFIL -->
        <div class="tenjityModule-modal" @mousedown.self="handleCloseProfilModal" v-if="isProfilModalActive">
            <div class="tenjityModule-modal-container">
                <div class="tenjityModule-modal-formContainer">
                    <label class="tenjityModule-modal-label" for="profilName">Nom du profil :</label>
                    <input class="tenjityModule-modal-input" ref="modalProfilInput" type="text" id="profilName"
                        @click="$event.stopPropagation()" v-model="newProfilName" />
                    <button class="tenjityModule-modal-btn" @click.stop="handleCreateUserProfil">Ajouter</button>
                </div>
                <Icon class="tenjityModule-modal-closeBtn" icon="fluent:add-16-filled"
                    @click="handleCloseProfilModal" />
            </div>
        </div>
    </div>
</template>
<script setup>
import AccessibilityFilters from "./components/AccessibilityFilters.vue";
import AccessibilityContent from "./components/AccessibilityContent.vue";
import AccessibilityZoom from "./components/AccessibilityZoom.vue";
import AccessibilityBtn from "./components/AccessibilityBtn.vue";
import AccessibilitySectionHeader from "./components/AccessibilitySectionHeader.vue";
import AccessibilityToggleProfil from "./components/AccessibilityToggleProfil.vue";
import { Icon } from "@iconify/vue";
import { addInputClass } from "./utils";
import { ref, toRefs, computed, nextTick, onMounted } from "vue";
import { useScreenReader } from "./composables/useScreenReader.js";
import { useDyslexicFont } from "./composables/useDyslexicFont.js";
import { useTranslation } from "./composables/useTranslation.js";
import { useContentFilter } from "./composables/useContentFilter.js";
import { useScreenRuler } from "./composables/useScreenRuler.js";
import { useCursor } from "./composables/useCursor.js";
import { useMagnifier } from "./composables/useMagnifier.js";
import { useModuleUI } from "./composables/useModuleUI.js";
import { useProfileSystem } from "./composables/useProfileSystem.js";
import { useZoom } from "./composables/useZoom.js";
import AccessibilityInput from "./components/AccessibilityInput.vue";
import AccessibilityModuleHashError from "./components/AccessibilityModuleHashError.vue";
import SimpleKeyboard from "./components/SimpleKeyboard";
import AccessibilitySwitch from "./components/AccessibilitySwitch.vue";
import MagnifierView from "./components/AccessibilityMagnifier.vue";

const navigationSectionRef = ref(null);
const accessibilityContent = ref(null);
const customSection = ref(null);
const sectionContent = ref(null);
const cursorRef = ref(null);
const screenRulerRef = ref(null);
const screenRulerTopRef = ref(null);
const screenRulerBottomRef = ref(null);
const magnifierViewRef = ref(null);
const modalProfilInput = ref(null);
const lastMouseRef = ref({ x: 0, y: 0 });
const isDarkModeActive = ref(false);
const isTouchDevice = computed(() => "ontouchstart" in window || !!navigator.msMaxTouchPoints);

function refreshSnapshot(delay = 0) {
    if (!magnifierViewRef.value) return;
    nextTick(() => magnifierViewRef.value.scheduleCapture(delay));
}

const screenReader = useScreenReader();
const dyslexicFont = useDyslexicFont();
const translation = useTranslation({ setVoiceForLanguage: screenReader.setVoiceForLanguage });
const magnifier = useMagnifier({ magnifierViewRef, refreshSnapshot });
const zoom = useZoom({ zoomWrapper: dyslexicFont.state.zoomWrapper, refreshSnapshot });
const { pageZoomSliderBg: zoomPageSliderBg, moduleZoomSliderBg: zoomModuleSliderBg, textZoomSliderBg: zoomTextSliderBg } = zoom;
const screenRuler = useScreenRuler({
    screenRulerRef,
    screenRulerTopRef,
    screenRulerBottomRef,
    lastMouseRef,
    isTouchDevice,
    refreshSnapshot,
});
const cursor = useCursor({
    cursorRef,
    lastMouseRef,
    isDarkModeRef: isDarkModeActive,
    refreshSnapshot,
});
const contentFilter = useContentFilter({
    navigationSectionRef,
    resetCursor: cursor.reset,
    resetMagnifier: magnifier.reset,
    resetScreenRuler: screenRuler.reset,
    resizeModule: () => moduleUI.resizeModule(),
});
const moduleUI = useModuleUI({
    accessibilityContentRef: accessibilityContent,
    customSectionRef: customSection,
    sectionContentRef: sectionContent,
    zoom,
    isDarkModeRef: isDarkModeActive,
    applyCursorThemeDefaults: cursor.applyCursorThemeDefaults,
    darkModeStorageKey: "tenjityModuleDarkMode",
    zoomWrapper: dyslexicFont.state.zoomWrapper,
    refreshSnapshot,
});
const profiles = useProfileSystem({
    zoom,
    sectionContentRef: sectionContent,
    modalProfilInputRef: modalProfilInput,
    cursor,
    magnifier,
    screenRuler,
    screenReader,
    dyslexicFont,
    moduleUI,
    isDarkModeRef: isDarkModeActive,
    refreshSnapshot,
});

// screenReader
const { manageScreenReader, setVoiceForLanguage, readText } = screenReader;

// dyslexicFont
const { fontForDyslexic, zoomWrapper } = toRefs(dyslexicFont.state);
const { setDyslexicFontState, applyDyslexicFont } = dyslexicFont;

// translation
const { isLoading } = toRefs(translation.state);
const { selectLang } = translation;

// contentFilter
const { contentsFilter, filteredContent, isShowModal, isNavigationSectionActive, input } = toRefs(contentFilter.state);
const { titleStyle, btnStyle, handleFilterContent, handleGetLinks, handleDisplayModal, handleHideModal, handleClickElement, toggleNavigationSection, resetNavigation, onChange, onKeyPress, onInputFocus, onInputBlur } = contentFilter;

// screenRuler
const { isScreenRulerActive, screenRulerColor, screenRulerHeight, screenRulerHeightStep, isScreenRulerSettingsMenuOpen } = toRefs(screenRuler.state);
const { toggleScreenRuler, checkToggleScreenRuler, toggleScreenRulerSettingsMenu, changeScreenRulerHeight, manageScreenRuler } = screenRuler;

// cursor
const { isCursorActive, cursorColor, normalCursorColor, hoverCursorColor, cursorScale, cursorScaleStep, isCursorPointer, isCursorSettingsMenuOpen } = toRefs(cursor.state);
const { toggleCursor, checkToggleCursor, handleCursor, listenerHandleCursor, changeCursorScale, changeScaleValue, handleCursorColorInput, getCursorThemeDefaults, applyCursorThemeDefaults, toggleCursorSettingsMenu } = cursor;

// magnifier
const { isMagnifierActive, magnifierZoom, magnifierSize, magnifierMode, magnifierFixedX, magnifierFixedY, magnifierCursorPosition, isMagnifierFrameVisible, isMagnifierSettingsMenuOpen } = toRefs(magnifier.state);
const { magnifierZoomMin, magnifierZoomMax, magnifierSizeMin, magnifierSizeMax, magnifierViewportWidth, magnifierViewportHeight, toggleMagnifier, checkToggleMagnifier, toggleMagnifierFrame, toggleMagnifierSettingsMenu, setMagnifierMode, changeMagnifierZoom, changeMagnifierSize, changeMagnifierFixedPosition, updateMagnifierFixedPosition, normalizeMagnifierFixedCoordinate } = magnifier;
const moduleZoomValueForMagnifier = computed(() => zoom.state.moduleZoomValue);
const pageZoomValueForMagnifier = computed(() => zoom.state.isZoomActive ? zoom.state.zoomValue : 100);

// moduleUI
const { isModuleActive, hasCustomCta, isZoomExpanded } = toRefs(moduleUI.state);
const { applyDarkMode, manageWidthOnToggleFont, resizeModule, toggleVisualZoomMenu, resetZoomGlobal, changeVisualProfileZoom, updateVisualProfileZoomValue } = moduleUI;
const toggleModule = () => moduleUI.toggleModule(magnifierViewRef);
const toggleDarkMode = () => { isDarkModeActive.value = !isDarkModeActive.value; };

// profiles
const { profils, profilFilters, profilContent, newProfilName, isProfilModalActive, userProfils, isColorsSettingsMenuOpen } = toRefs(profiles.state);
const { toggleProfil, handleOpenProfilModal, handleCloseProfilModal, handleCreateUserProfil, toggleUserProfil, deleteUserProfil, applyActiveProfil, resetProfil, activeProfil, toggleColorsSettingsMenu, updateFiltersActive } = profiles;

onMounted(async () => {
    window.toggleModule = toggleModule;
    isDarkModeActive.value = JSON.parse(window.localStorage.getItem("tenjityModuleDarkMode")) || false;
    applyDarkMode();
    applyCursorThemeDefaults(true);
    try {
        userProfils.value = JSON.parse(window.localStorage.getItem("tenjityModuleProfils")) || [];
    } catch {
        userProfils.value = [];
    }
    applyActiveProfil();
    const savedTextZoom = parseInt(window.localStorage.getItem("tenjityTextZoom"));
    if (savedTextZoom) {
        zoom.setTextZoomLevel(savedTextZoom);
    }
    console.warn("You are not registered to use tenjity module, please go to https://tenjity.com to register");
    addInputClass();
});
</script>

<style lang="scss">
.tenjity-loader {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(255, 255, 255, 0.5);
    z-index: 2147483647; // Max z-index
    display: flex;
    justify-content: center;
    align-items: center;
}

.tenjity-spinner {
    width: 50px;
    height: 50px;
    border: 5px solid #f3f3f3;
    border-top: 5px solid #ffcd07;
    /* Tenjity yellow */
    border-radius: 50%;
    animation: tenjity-spin 1s linear infinite;
}

@keyframes tenjity-spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>